
import { createHelpers } from 'vuex-map-fields';
import Solicitudsvc from "@/services/solicitudes";
import constantes from '@/constantes'
const { getSolicitudField } = createHelpers({
  getterType: 'getSolicitudField'
});

export default {
  namespaced: true,
  state: {
    search:'',
    articulosEscuela:['Art30','Art17','Art20','Art20a','Art20b','Art20c'],
    filtro: JSON.parse(window.sessionStorage.getItem('filtro')) !== null ? JSON.parse(window.sessionStorage.getItem('filtro')) :
    {
      sortBy: {
        selected: 0,
        opciones:[
          { value: 0, text: "Fecha de modificación" },
          { value: 6, text: "Fecha de Creación" },
          { value: 1, text: "Apellido" },
          { value: 2, text: "DNI" },
          { value: 3, text: "Fecha de Presentación" },
          { value: 4, text: "Estado" },
          { value: 5, text: "Tipo" },
        ]
      },
      orderBy:{
        selected: 'desc',
        opciones:[
          { value: 'desc', text: "Descendente" },
          { value: 'asc', text: "Ascendente" },
        ]
      },
      presentacion:{
        desde: null,
        hasta: null,
      },
      search:{
        text : '',
        tipoBusqueda:{
          selected: 'Apellido',
          opciones: [
            { value: '0', text: "DNI" },
            { value: '1', text: "Apellido" },
            { value: '2', text: "Nombre" },
            { value: '3', text: "Id" },
          ]
        },
      },
      establecimiento:null,
      estado: {
        selected: 0,
        opciones: [],
      },
      tipo: {
        selected: -1,
        opciones: [
          { value: -1, text: '--Seleccionar--' },
          { value: 0, text: 'Medica' },
          { value: 1, text: 'Legal'},
          { value: 2, text: 'Institucional'},
          // { value: 0, text: 'Medica' },
          // { value: 1, text: 'Accidente'},
          // { value: 2, text: 'Covid'},
          // //{ value: 3, text: 'Vacaciones'},
          // { value: 4, text: 'Artículo 17'},
          // { value: 10, text: 'Artículo 20 a'},
          // { value: 11, text: 'Artículo 20 b'},
          // { value: 12, text: 'Artículo 20 c'},
          // { value: 5, text: 'Artículo 30'},
          // { value: 6, text: 'Artículo 32'},
          // { value: 7, text: 'Artículo 33'},
          // { value: 13, text: 'Artículo 27'},
          // { value: 8, text: 'Artículo 28'},
          // { value: 9, text: 'Artículo 14ext'}
        ]
      },
      destino: {
        selected: 0,
        opciones:[
          { value: 0, text: "--Seleccionar--" },
          { value: 1, text: "Nivel" },
          { value: 2, text: "Unidad Educativa" },
          { value: 3, text: "SAED" }
        ]
      }
    },
    tabla:{
      items:[],
      fields: [
        {
          key: 'Id',
          label: 'Cod.',
          class: 'text-center'
        },
        {
          key: 'FechaDesde',
          label: 'Aus. desde',
          class: 'text-center',
          formatter: 'fechaFormatter'
        },
        {
          key: 'ToString',
          label: 'Fecha y hora de envío /  Estado / DNI - Apellido y Nombre',
          formatter: 'valueFormatter'
        },
        {
          key: 'ListaCargoPersonalString',
          label: 'Cargos',
          formatter: 'listaCargoPersonalFormatter'
        },
        {
          key: 'acciones',
          label: 'Acciones',
          class: 'text-center',
        }
      ],
      error: {
        activo: false,
        mensaje: '',
        status:{
          mensaje: '',
          devMensaje: '',
          listaMensaje: [],
          morInfo:'',
          statusCode:0
        }
      },
      rows: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 25, 50],
    },
    formdata: null,
    formulario:{
      EstadoSolicitudMedica: 0,
      Fecha: null,
      FechaDesde: null,
      FechaHasta: null,
      FechaPresentacion:null,
      TipoSolicitudMedica: 0,
      Personal_Id: 0,
      unidadeducativa_id: 0,
      nivelenseñanza_id: 0,
      UnidadAdministrativa_Id: 1,
      ListaCargoPersonal_Id: 0,
      Observaciones: ''
    },
    selected:{
      id: -1,
      objeto: null,
      tablahistorial:{
        items:[],
        fields: [
          {
            key: 'UsuarioString',
            label: 'Operador',
            formatter: 'valueFormatter'
          },
          {
            key: 'Fecha',
            label: 'Fecha',
            formatter: 'fechaHoraFormatter'
          },
          {
            key: 'EstadoSolicitudMedica',
            label: 'Estado',
            formatter: 'valueFormatter'
          },
          {
            key: 'DisplayEstablecimiento',
            label: 'Establecimiento',
            formatter: 'valueFormatter'
          },
          {
            key: 'Observaciones',
            label: 'Observaciones',
            formatter: 'stringFormatter'
          },
          {
            key: 'acciones',
            label: 'Acciones'
          }
        ],
      },
      tablacargos: constantes.tablacargos
    }
  },
  mutations: {
    getSolicitudField,
    setTablaRows (state, data) {
      console.log('mutation.setTabla', data);
      state.tabla.rows = data.rows;
      state.tabla.totalRows = data.total;
    },
    setTablaError (state, data) {
      console.log('mutation.setTablaError', data);
      state.tabla.error.activo = data.activo;
      state.tabla.error.mensaje = data.mensaje;
      state.tabla.status = data.status;
    },
    setFiltroEstablecimiento (state, data) {
      console.log('mutation.setFiltroEstablecimiento', data);
      state.filtro.establecimiento = data;
    },
    clearSelected (state){
      console.log('mutation.clearSelected');
      state.selected.id = -1;
      state.selected.tablacargos.items = [];
      state.selected.tablahistorial.items = [];
    },
    handleErrorResponse (state, data){
      console.log('mutation.handleErrorResponse');
      var mensajelocal = '';
      if(data.Message !== null){
        mensajelocal = data.Message;
      }else{
        mensajelocal = data.status.mensaje;
        state.tabla.status = data.status;
      }
      state.tabla.error.activo = true;
      state.tabla.error.mensaje = mensajelocal;
    },
  },
  getters: {
    getSolicitudField,
  },
  actions: {
    setTablaError (ctx, data) {
      console.log('action.setTablaError', data);
      ctx.commit('setTablaError', data);
    },
    setFiltroEstablecimiento (ctx, data) {
      console.log('action.setFiltroEstablecimiento', data);
      ctx.commit('setFiltroEstablecimiento', data);
    },
    getFormData (ctx, id) {
      console.log("action.getFormData: ",id);
      return Solicitudsvc.getFormData({
        id: id,
      }).then(e => {
        console.log("action.getFormData: ",e.data);
        ctx.state.formdata = e.data.objeto;
        return e.data.objeto;
      }).catch(error => {
        console.log("Error en getFormData",error.response.data);
        console.log(error.response.data);
        var responseData = error.response.data;
        ctx.commit('handleErrorResponse', responseData);
      });
    },
    setFiltroEstado (ctx, selected){
      console.log("action.setFiltroEstado");
      if(ctx.state.formdata !== null){
        ctx.state.filtro.estado.opciones = ctx.state.formdata.ListaEstadoSolicitudMedica.Lista.reduce(function(filtered, item) {
          if (item.Id === 8 || item.Id === 4 || item.Id === 5 || item.Id === 1 || item.Id === 7) {
            var newValue = { text: item.Text, value: item.Id }
            filtered.push(newValue);
          }
          if (item.Id === 0) {
            var newValue = { text: '--Seleccionar--', value: item.Id }
            filtered.push(newValue);
          }
          if (item.Id === 10) {
            var newValue = { text: 'Fuera de Término', value: item.Id }
            filtered.push(newValue);
          }
          if (item.Id === 12) {
            var newValue = { text: 'Alta Médica', value: item.Id }
            filtered.push(newValue);
          }
          if (item.Id === 13) {
            var newValue = { text: 'Licencia Finalizada', value: item.Id }
            filtered.push(newValue);
          }
          if (item.Id === 14) {
            var newValue = { text: 'No Autorizado', value: item.Id }
            filtered.push(newValue);
          }
          return filtered;
        }, []);
      }
      ctx.state.filtro.estado.selected = selected ? selected : 0;
    },
    setFiltroFechaPresentacion(ctx, date){
      console.log("action.setFiltroFechaPresentacion: ",date);
      ctx.state.filtro.presentacion = date;
    },
    getSolicitud (ctx, id) {
      console.log("action.getSolicitud: ",id);
      ctx.commit('clearSelected');
      ctx.state.selected.id = id;
      return Solicitudsvc.get({
        id: id,
        incluyecargopersonal: true,
        incluyelicenciacargopersonal: true,
        incluyehistorialsolicitudmedica: true
      }).then(e => {
        console.log("action.getSolicitud then: ",e.data);
        ctx.state.selected.objeto = e.data.objeto;
        ctx.state.selected.tablahistorial.items = e.data.objeto.Historial;
        ctx.state.selected.tablacargos.items = e.data.objeto.ListaCargoPersonal;
      }).catch(error => {
        console.log("Error en getSolicitud",error.response.data);
        console.log(error.response.data);
        var responseData = error.response.data;
        ctx.commit('handleErrorResponse', responseData);
        ctx.commit('clearSelected');
      });
    },
    solicitudProvider (ctx, resetPagination) {
      window.sessionStorage.setItem('filtro', JSON.stringify(ctx.state.filtro));
      console.log("action.solicitudProvider", ctx);
      console.log("action.solicitudProvider establecimiento", ctx.state.filtro.establecimiento);
      ctx.commit('clearSelected');
      if(resetPagination != ctx.state.tabla.currentPage){
        ctx.state.tabla.currentPage = resetPagination;
      }
      return Solicitudsvc.getLista({
        incluyelicenciacargopersonal: ctx.state.filtro.estado.selected === 8 || ctx.state.filtro.estado.selected === 0 ?  true : false,
        apellido: ctx.state.filtro.search.tipoBusqueda.selected === 'Apellido' ? ctx.state.filtro.search.text : '',
        nombre: ctx.state.filtro.search.tipoBusqueda.selected === 'Nombre' ? ctx.state.filtro.search.text : '',
        dni: ctx.state.filtro.search.tipoBusqueda.selected === 'DNI' ? ctx.state.filtro.search.text : '',
        id: ctx.state.filtro.search.tipoBusqueda.selected === 'Id' ? ctx.state.filtro.search.text : '',

        fechapresentaciondesde: ctx.state.filtro.presentacion.desde,
        fechapresentacionhasta: ctx.state.filtro.presentacion.hasta,

        // Antes estaba hardcodeado en 1 (siempre "SAED"), lo que excluía de la
        // búsqueda cualquier solicitud de instituciones de otra unidad
        // administrativa (ej. UnidadAdministrativa_Id 3). Se calcula igual que
        // unidadeducativa_id/nivelenseñanza_id, según el filtro elegido.
        unidadadministrativa_id: ctx.state.filtro.destino.selected !== 0
          ? 0 : ctx.state.filtro.establecimiento
          ? ctx.state.filtro.establecimiento.UnidadAdministrativa_Id
          : 0,
        estadosolicitudmedica: ctx.state.filtro.estado.selected,
        //tiposolicitudmedica: ctx.state.filtro.tipo.selected,
        tiposolicitudmedica: -1,
        tiposolicitudlicencia: ctx.state.filtro.tipo.selected,
        //destinosolicitud: ctx.state.filtro.destino.selected,

        unidadeducativa_id:  ctx.state.filtro.destino.selected !== 0
          ? 0 : ctx.state.filtro.establecimiento
          ? ctx.state.filtro.establecimiento.UnidadEducativa_Id
          : 0,
        nivelenseñanza_id: ctx.state.filtro.destino.selected !== 0
          ? ctx.state.filtro.destino.selected : ctx.state.filtro.establecimiento
          ? ctx.state.filtro.establecimiento.NivelEnseñanza_Id
          : 0,
        offset: (ctx.state.tabla.currentPage - 1) * ctx.state.tabla.perPage,
        limit: ctx.state.tabla.perPage,
        //search: ctx.state.filtro.search.text,
        order: ctx.state.filtro.orderBy.selected,
        sort: ctx.state.filtro.sortBy.selected
      }).then(r => {
          console.log("action.solicitudProvider then", r.data);
          console.log(r);
          ctx.commit('setTablaError', { activo: false, mensaje: ''});
          ctx.commit('setTablaRows', r.data);
          return r.data.rows;
        })
        .catch(error => {
          console.log("Error en solicitudProvider",error.response.data);
          console.log(error.response.data);
          var responseData = error.response.data;
          ctx.commit('handleErrorResponse', responseData);
          ctx.commit('setTablaRows', { rows : []});
        });
    },
  cambiarEstado (ctx, item) {
      console.log("action.cambiarEstado: ",item);
      ctx.commit('clearSelected');
      ctx.state.selected.id = item.id;

      return Solicitudsvc.cambiarestado({
        EstadoSolicitudMedica: item.estado.value,
        Observaciones: item.observaciones,
        Id: item.id,
        nivelenseñanza_id: item.nivelenseñanza_id,
        unidadeducativa_id: item.unidadeducativa_id,
        unidadadministrativa_id: item.unidadadministrativa_id,
        ListaCargoPersonal_Id: item.ListaCargoPersonal_Id ? item.ListaCargoPersonal_Id : null
      }).then(e => {
        console.log("action.cambiarEstado then: ",e.data);
        var itemChange = ctx.state.tabla.rows.find(obj => {
          return obj.Id === item.id;
        });
        console.log('itemChange',itemChange);
        itemChange.EstadoSolicitudMedicaString = item.estado.text;
        return e;
      }).catch(error => {
        console.log("Error en getSolicitud",error.response.data);
        console.log(error.response.data);
        var responseData = error.response.data;
        ctx.commit('handleErrorResponse', responseData);
        ctx.commit('clearSelected');
      });
    },
    eliminar (ctx, item) {
      console.log("action.eliminar: ",item);
      ctx.commit('clearSelected');
      ctx.state.selected.id = item.Id;
      return Solicitudsvc.eliminar(item).then(e => {
        console.log("action.eliminar then: ",e.data);
        return e;
      }).catch(error => {
        console.log("Error en getSolicitud",error.response.data);
        console.log(error.response.data);
        var responseData = error.response.data;
        ctx.commit('handleErrorResponse', responseData);
        ctx.commit('clearSelected');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/solicitudmodule.js